<template>
  <tr :class="{invited: !member.is_active, hover: isAdmin}" @click="onClickRow">
    <td>
      {{member.email}}
    </td>
    <td>
      <div class="invite-fineprint" v-if="!member.is_active">
          <i class="fa fa-envelope" />
          <span v-if="sending">Sending...</span>
          <span v-else>Invite sent!</span>
      </div>
      <span v-else>{{member.date_joined.substring(0,10)}}</span>
    </td>
    <td>
      {{userRoleText()}}
    </td>
    <td v-if="flags.showLastOrderDate">
      {{ member.last_order_date ? member.last_order_date.substring(0,10) : '' }}
    </td>
  </tr>
</template>

<style scoped lang="scss">
@import '~scss/colors';
tr.hover:hover {
  background-color: $white;
  box-shadow: 2px 4px 2px $gray-1;
}
td {
  vertical-align: center;
}
.invited {
  color: #ccc;
}
.invite-fineprint {
  font-size: medium;
  color:$alert-link-blue;
}
</style>
<style lang="scss">
// Unscoped to affect the button within b-dropdown
.transparent-bg button {
  background: transparent;
}
</style>

<script>
import { mapGetters } from "vuex";
export default {
  props: ['member'],
  data() {
    return {sending: false};
  },
  computed: {
    ...mapGetters(["user", "isAdmin", "flags"])
  },
  methods: {
    onClickRow() {
      if (this.isAdmin) {
        this.$router.push({ name: 'member-detail', params: { id: this.member.id }});
      }
    },
    userRoleText() {
      // Return a label for the user type. If we get an unexpected user_type, just return that.
      return {admin: 'Administrator', user: 'Orderer'}[this.member.user_type] || this.member.user_type;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/team/MemberRow.vue